import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-wrapper" }
const _hoisted_2 = { class: "settings-group" }
const _hoisted_3 = { class: "settings-group-title" }
const _hoisted_4 = { class: "d-flex align-items-center" }

import { useUserSettings } from "@common/composable/useRootStore";
import { onMounted } from "vue";
import { watch } from "vue";
import { reactive } from "vue";

type ViewModel = {
  IsTranslationDetailViewVisible: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewOptionsModal',
  setup(__props) {

const { userSettings, saveUserSettings } = useUserSettings();

const vm = reactive<ViewModel>({
  IsTranslationDetailViewVisible: false
});

watch(
  () => vm,
  (newValue) => {
    saveUserSettings(newValue);
  },
  {
    deep: true
  }
);

watch(
  () => userSettings.value.IsTranslationDetailViewVisible,
  (newValue) => {
    Object.assign(vm, {
      IsTranslationDetailViewVisible: newValue === true || newValue === "true"
    });
  }
);

onMounted(() =>
  Object.assign(vm, {
    IsTranslationDetailViewVisible: userSettings.value.IsTranslationDetailViewVisible === true || userSettings.value.IsTranslationDetailViewVisible === "true"
  })
);

return (_ctx: any,_cache: any) => {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    "body-class": "view-options-modal",
    id: "view-options-modal",
    title: _ctx.$t('menubar.view'),
    "ok-only": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("General")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_b_form_checkbox, {
              modelValue: vm.IsTranslationDetailViewVisible,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.IsTranslationDetailViewVisible) = $event)),
              switch: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("translationManager.isTranslationDetailViewVisible")), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})